var generateStyle = function generateStyle(componentTheme) {
  return {
    headerContainer: {
      paddingBottom: componentTheme.headerPaddingBottom
    },
    closeIconContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginRight: '-10px',
      marginTop: '-10px'
    }
  };
};
export default generateStyle;